import { Avatar, ChakraBox, ChakraFlex, ChakraText } from '@equip.health/ui';

import MaiChatTimestamp from './MaiChatTimestamp';

interface MaiChatUserMessageProps {
  text: string;
  createdAt: string;
  clinicianName: string;
}

const MaiChatUserMessage = ({
  text,
  createdAt,
  clinicianName,
}: MaiChatUserMessageProps) => {
  return (
    <ChakraFlex
      data-testid="mai-chat-user-message"
      alignItems="flex-start"
      justifyContent="flex-end"
      gap="10px"
    >
      <ChakraFlex
        direction="column"
        alignItems="flex-end"
        gap="4px"
        maxWidth="80%"
      >
        <ChakraBox
          background="primary.100"
          color="neutral.background.primary"
          padding="10px 14px"
          borderRadius="14px 14px 4px 14px"
        >
          <ChakraText fontSize="14px" lineHeight="1.5" whiteSpace="pre-wrap">
            {text}
          </ChakraText>
        </ChakraBox>
        <MaiChatTimestamp createdAt={createdAt} />
      </ChakraFlex>
      <Avatar
        name={clinicianName}
        size="xs"
        userType="provider"
        aria-label={`${clinicianName} avatar`}
      />
    </ChakraFlex>
  );
};

export default MaiChatUserMessage;
